// Fictional "Dzherelo" secondary school. History teacher and form teacher of 8-A.
// See README.md for the schema.
export default {
  id: 'teacher',
  occupationId: '66b280672a4e4285b87ebf1d',
  occupationName: { en: 'Teacher', ua: 'Вчитель' },
  format: 'classroom',
  title: { en: 'A day as a school teacher', ua: 'День шкільного вчителя' },
  tagline: {
    en: "Five lessons, a parents' chat on fire and a student who does not want to go home",
    ua: 'П’ять уроків, батьківський чат, що палає, і учениця, яка не хоче йти додому'
  },
  minutes: 10,
  intro: {
    en: "You teach history at Dzherelo, a secondary school of 600 students, and you are the form teacher of 8-A. It is Wednesday: five lessons, a test to hand back, an open lesson on Friday to prepare, and a parents' group chat that never sleeps.",
    ua: 'Ти вчитель історії в ліцеї «Джерело» на 600 учнів і класний керівник 8-А. Середа: п’ять уроків, повернути контрольну, підготувати відкритий урок на п’ятницю й батьківський чат, який ніколи не спить.'
  },
  goal: {
    en: 'Get 8-A through the day having learned something, with no fires left in the chat',
    ua: 'Провести 8-А через день так, щоб вони чогось навчились, а в чаті нічого не горіло'
  },
  kpis: [
    { key: 'learning', label: { en: 'Learning', ua: 'Навчання' }, start: 60 },
    { key: 'climate', label: { en: 'Class climate', ua: 'Клімат у класі' }, start: 65 },
    { key: 'admin', label: { en: 'Paperwork', ua: 'Папери' }, start: 50 }
  ],
  competencies: [
    {
      key: 'pedagogy',
      label: { en: 'Pedagogy', ua: 'Методика' },
      skill: { _id: '686282c1aa8e5a92e3bc151f', name: 'Методика викладання історії' }
    },
    {
      key: 'classroom',
      label: { en: 'Classroom management', ua: 'Керування класом' },
      skill: { _id: '686282c1aa8e5a92e3bc1343', name: 'Вирішення конфліктів' }
    },
    {
      key: 'communication',
      label: { en: 'Communication', ua: 'Комунікація' },
      skill: { _id: '686282c1aa8e5a92e3bc133c', name: 'Комунікативність' }
    },
    {
      key: 'organisation',
      label: { en: 'Organisation', ua: 'Організованість' },
      skill: { _id: '686282c1aa8e5a92e3bc135a', name: 'Організаційні здібності' }
    },
    {
      key: 'care',
      label: { en: 'Care', ua: 'Турбота' },
      skill: { _id: '686282c1aa8e5a92e3bc133f', name: 'Емпатія' }
    }
  ],
  people: [
    {
      key: 'mother',
      name: { en: 'Iryna', ua: 'Ірина Петрівна' },
      role: { en: "Maksym's mother", ua: 'Мама Максима' },
      initials: 'IP',
      color: '#d5921b'
    },
    {
      key: 'father',
      name: { en: 'Oleh', ua: 'Олег' },
      role: { en: "Sofiia's father", ua: 'Тато Софії' },
      initials: 'OL',
      color: '#e25510'
    },
    {
      key: 'colleague',
      name: { en: 'Halyna', ua: 'Галина Степанівна' },
      role: { en: 'Maths teacher', ua: 'Вчителька математики' },
      initials: 'HS',
      color: '#19857b'
    },
    {
      key: 'principal',
      name: { en: 'Viktor', ua: 'Віктор Іванович' },
      role: { en: 'Principal', ua: 'Директор' },
      initials: 'VI',
      color: '#30b0c7'
    },
    {
      key: 'maksym',
      name: { en: 'Maksym', ua: 'Максим' },
      role: { en: 'Student, 8-A', ua: 'Учень 8-А' },
      initials: 'MA',
      color: '#4f9a04'
    },
    {
      key: 'sofiia',
      name: { en: 'Sofiia', ua: 'Софія' },
      role: { en: 'Student, 8-A', ua: 'Учениця 8-А' },
      initials: 'SO',
      color: '#9c27b0'
    },
    {
      key: 'psych',
      name: { en: 'Alina', ua: 'Аліна' },
      role: { en: 'School psychologist', ua: 'Шкільна психологиня' },
      initials: 'AL',
      color: '#7b1fa2'
    }
  ],
  steps: [
    {
      type: 'chat',
      id: 's1',
      at: '07:50',
      comp: ['communication', 'care'],
      traits: ['S', 'E'],
      messages: [
        {
          from: 'mother',
          text: {
            en: "8-A parents: Good morning. Maksym got a 5 for the history test. I saw Sofiia's paper, same answers, she got a 9. I would like an explanation here, so everyone sees how grades are given in this class.",
            ua: 'Батьки 8-А: Доброго ранку. Максим отримав 5 за контрольну з історії. Я бачила роботу Софії, відповіді ті самі, у неї 9. Хотіла б пояснення тут, щоб усі бачили, як у цьому класі ставлять оцінки.'
          }
        },
        {
          from: 'father',
          text: {
            en: "Iryna, I am not sure Sofiia's paper belongs in this chat, but I would also like to understand the criteria.",
            ua: 'Ірино, не впевнений, що робота Софії має обговорюватись у чаті, але критерії теж хотів би зрозуміти.'
          }
        }
      ],
      prompt: { en: 'What do you write in the group?', ua: 'Що пишеш у групу?' },
      options: [
        {
          text: {
            en: "Good morning. I do not discuss a child's grades in the group; that is between the family and me. Iryna, I will call you at 13:10 with Maksym's paper in front of me. The test criteria go to everyone today as a file.",
            ua: 'Доброго ранку. Оцінки дитини в групі не обговорюю, це між родиною і мною. Ірино Петрівно, зателефоную вам о 13:10 з роботою Максима перед собою. Критерії контрольної сьогодні надішлю всім файлом.'
          },
          q: 'best',
          fx: { climate: 4, trust: 4 },
          fb: {
            en: "The group hears a rule and a time, not a defence. One parent gets a real conversation, the rest get the criteria without anyone's child on display.",
            ua: 'Група чує правило й час, а не виправдання. Одна мама отримує справжню розмову, решта — критерії без чиєїсь дитини на видноті.'
          }
        },
        {
          text: {
            en: 'Good morning. The test had four parts: facts, dates, source analysis and an essay. Maksym lost most of his points on the essay and the source. Happy to show the papers side by side to anyone who wants.',
            ua: 'Доброго ранку. У контрольній було чотири частини: факти, дати, аналіз джерела та есе. Максим втратив більшість балів на есе й джерелі. Радо покажу роботи поруч усім, хто захоче.'
          },
          q: 'ok',
          fx: { trust: 1, climate: -3 },
          fb: {
            en: "Accurate and open, but you just discussed a 13-year-old's weak essay in front of 28 families. Maksym will hear about it at school by the second lesson.",
            ua: 'Точно й відкрито, але ти щойно обговорив слабке есе 13-річного перед 28 родинами. Максим почує про це в школі вже на другому уроці.'
          }
        },
        {
          text: {
            en: "Good morning. Grades are given strictly by the criteria, and I would ask parents not to compare other children's papers. If anyone doubts my objectivity, the principal's office is open.",
            ua: 'Доброго ранку. Оцінки виставляються суворо за критеріями, і я прошу батьків не порівнювати роботи чужих дітей. Якщо хтось сумнівається в моїй об’єктивності, кабінет директора відкритий.'
          },
          q: 'bad',
          fx: { trust: -6, climate: -4 },
          fb: {
            en: 'Every word is defensible and the whole message reads as "go complain". A parent asked a question in public and got pointed at a door.',
            ua: 'Кожне слово можна захистити, а разом повідомлення читається як «ідіть скаржтесь». Мама поставила запитання публічно й отримала вказівку на двері.'
          },
          later: {
            after: 2,
            note: {
              en: 'Iryna wrote to the principal. Viktor wants "two minutes" with you after lesson 4.',
              ua: 'Ірина Петрівна написала директору. Віктор Іванович хоче «дві хвилини» після четвертого уроку.'
            },
            fx: { admin: -4 }
          }
        },
        {
          text: {
            en: 'Leave it unanswered until the evening. The chat runs hot at 8 in the morning, and by tonight it will have moved on to the school trip and the money for the curtains.',
            ua: 'Не відповідати до вечора. О восьмій ранку чат кипить, а до вечора вже перейде на тему екскурсії та грошей на штори, як завжди буває.'
          },
          q: 'bad',
          fx: { trust: -4, climate: -3 },
          fb: {
            en: 'Silence in a group chat is read as guilt. By the evening there are 40 messages, two theories about you and a screenshot sent to the principal.',
            ua: 'Мовчання в груповому чаті читають як провину. До вечора там 40 повідомлень, дві теорії про тебе і скріншот, надісланий директору.'
          }
        }
      ],
      principle: {
        en: 'Rules in public, grades in private, always with a time.',
        ua: 'Правила публічно, оцінки приватно, і завжди з часом.'
      }
    },
    {
      type: 'choice',
      id: 's2',
      at: '08:35',
      comp: ['classroom'],
      traits: ['S', 'E'],
      text: {
        en: 'Lesson 1, 8-A, the Cossack era. Danylo in the back row comments on every slide, the class laughs, and after the third joke he says out loud: "This is boring anyway, nobody needs it." Twenty-six faces turn to you.',
        ua: 'Перший урок, 8-А, козацька доба. Данило з останньої парти коментує кожен слайд, клас сміється, а після третього жарту каже вголос: «Це й так нудно, нікому не треба». Двадцять шість облич дивляться на тебе.'
      },
      options: [
        {
          text: {
            en: 'Keep your voice level: "Danylo, you are good at commentary. The next slide is yours: tell us what you see on this map." Talk to him alone after the bell.',
            ua: 'Рівним голосом: «Данило, ти добре коментуєш. Наступний слайд твій: скажи, що бачиш на цій мапі». Після дзвінка поговорити з ним наодинці.'
          },
          q: 'best',
          fx: { climate: 5, learning: 3 },
          fb: {
            en: 'The class sees you unbothered, and Danylo gets attention through work instead of against it. The private talk is where the real reason usually comes out.',
            ua: 'Клас бачить, що тебе не вибило, а Данило отримує увагу через роботу, а не проти неї. Справжня причина зазвичай випливає в розмові наодинці.'
          }
        },
        {
          text: {
            en: 'Move him to the front desk next to you for the rest of the lesson, without a word of comment, and carry on with the slide as if nothing happened.',
            ua: 'Без жодного коментаря пересадити його за першу парту біля себе до кінця уроку й продовжити зі слайдом, ніби нічого не сталося.'
          },
          q: 'ok',
          fx: { climate: 1 },
          fb: {
            en: 'Quiet and quick, and the lesson survives. But the move answers the noise, not the "nobody needs it", so you will hear it again on Friday.',
            ua: 'Тихо й швидко, урок виживає. Але пересадка відповідає на шум, а не на «нікому не треба», тож у п’ятницю почуєш це знову.'
          }
        },
        {
          text: {
            en: 'Send him out to the corridor: "You can tell the principal what is boring." The rest of the class will think twice before joking now.',
            ua: 'Виставити в коридор: «Директору розкажеш, що нудно». Решта класу тепер двічі подумає, перш ніж жартувати на уроці.'
          },
          q: 'bad',
          fx: { climate: -6, admin: -2 },
          fb: {
            en: 'He won: the lesson stopped, he has an audience in the corridor and a story for the chat. The class learned that a joke can move you.',
            ua: 'Він виграв: урок зупинився, у нього публіка в коридорі й історія для чату. Клас зрозумів, що тебе можна вибити жартом.'
          }
        },
        {
          text: {
            en: 'Answer in kind: "If it is boring, next week\'s test will be extra interesting for you." A little sarcasm keeps 13-year-olds in line.',
            ua: 'Відповісти тим самим: «Якщо нудно, контрольна наступного тижня буде для тебе особливо цікавою». Трохи сарказму тримає 13-річних у рамках.'
          },
          q: 'bad',
          fx: { climate: -5, trust: -3 },
          fb: {
            en: 'Sarcasm from an adult is a threat with a smile, and the class hears the threat. You have just told them grades are a weapon.',
            ua: 'Сарказм від дорослого — погроза з усмішкою, і клас чує саме погрозу. Ти щойно сказав їм, що оцінки — зброя.'
          }
        }
      ],
      principle: {
        en: 'Give the disruptor a job, not a stage.',
        ua: 'Дай порушнику роботу, а не сцену.'
      }
    },
    {
      type: 'triage',
      id: 's3',
      at: '09:25',
      comp: ['organisation'],
      traits: ['C', 'S'],
      text: {
        en: 'The break is ten minutes and five things are waiting. Put them in the order you will take them.',
        ua: 'Перерва десять хвилин, а чекають п’ять справ. Розстав їх у порядку, в якому візьмешся.'
      },
      items: [
        {
          id: 'crying',
          title: { en: 'Sofiia is crying by the window', ua: 'Софія плаче біля вікна' },
          detail: {
            en: 'Her bag with her phone is gone from the classroom. She does not want to go to lesson 2.',
            ua: 'З класу зник її рюкзак із телефоном. На другий урок іти не хоче.'
          }
        },
        {
          id: 'journal',
          title: { en: 'Safety briefing log for 8-A', ua: 'Журнал інструктажу з безпеки для 8-А' },
          detail: {
            en: 'The principal needs it signed by 12:00 for the inspection; it takes 15 minutes.',
            ua: 'Директору треба підписаний до 12:00 для перевірки; це 15 хвилин.'
          }
        },
        {
          id: 'call',
          title: { en: 'Call Iryna back', ua: 'Передзвонити Ірині Петрівні' },
          detail: {
            en: 'You promised 13:10. She has just messaged asking if it can be earlier.',
            ua: 'Ти обіцяв о 13:10. Вона щойно написала, чи можна раніше.'
          }
        },
        {
          id: 'grading',
          title: { en: 'Grade the 8-B tests', ua: 'Перевірити контрольні 8-Б' },
          detail: {
            en: '28 papers, the class expects them tomorrow. About 90 minutes of work.',
            ua: '28 робіт, клас чекає завтра. Близько 90 хвилин роботи.'
          }
        },
        {
          id: 'open',
          title: {
            en: "Slides for Friday's open lesson",
            ua: 'Слайди для відкритого уроку в п’ятницю'
          },
          detail: {
            en: 'The deputy head will attend. Nothing is started yet.',
            ua: 'Прийде заступниця директора. Ще нічого не почато.'
          }
        }
      ],
      correctOrder: ['crying', 'journal', 'call', 'grading', 'open'],
      explain: {
        en: 'A crying child in front of you comes before any paper; three minutes now save a lost lesson. The log has a hard noon deadline with an inspection behind it. The call is a promise to a person: it stays at 13:10 and gets a reply now, not a reshuffle. Grading is due tomorrow, the open lesson on Friday.',
        ua: 'Дитина, яка плаче перед тобою, важливіша за будь-який папір; три хвилини зараз рятують втрачений урок. У журналу жорсткий дедлайн опівдні, а за ним перевірка. Дзвінок — обіцянка людині: лишається о 13:10 і отримує відповідь зараз, а не перенесення. Перевірка робіт — на завтра, відкритий урок — у п’ятницю.'
      },
      fx: { ok: { admin: 4, climate: 3 }, fail: { admin: -4, energy: -4 } }
    },
    {
      type: 'allocate',
      id: 's4',
      at: '10:20',
      comp: ['pedagogy', 'classroom'],
      traits: ['A', 'I'],
      text: {
        en: 'Lesson 3 is new material for 8-A: the Union of Lublin. You have 45 minutes. Split the time across four parts, remembering what 13-year-olds can hold their attention on.',
        ua: 'Третій урок — нова тема для 8-А: Люблінська унія. У тебе 45 хвилин. Розподіли час між чотирма частинами, пам’ятаючи, на чому 13-річні здатні втримати увагу.'
      },
      buckets: [
        {
          id: 'recap',
          label: { en: 'Recap of last lesson', ua: 'Повторення минулого уроку' },
          hint: {
            en: 'Memory needs a hook; two questions do it, a re-lecture does not.',
            ua: 'Пам’яті потрібен гачок: два запитання працюють, повторна лекція ні.'
          },
          best: 15
        },
        {
          id: 'new',
          label: { en: 'New material, teacher talking', ua: 'Новий матеріал, говорить учитель' },
          hint: {
            en: 'Attention on one voice lasts 12–15 minutes at this age.',
            ua: 'Увага до одного голосу в цьому віці тримається 12–15 хвилин.'
          },
          best: 35
        },
        {
          id: 'group',
          label: { en: 'Group work with a source', ua: 'Робота в групах із джерелом' },
          hint: {
            en: 'Groups need at least 12 minutes to do anything but shuffle chairs.',
            ua: 'Групам потрібно щонайменше 12 хвилин, щоб зробити щось, крім пересування стільців.'
          },
          best: 35
        },
        {
          id: 'check',
          label: { en: 'Exit check', ua: 'Перевірка наприкінці' },
          hint: {
            en: 'Three questions on paper show you who got it before the bell.',
            ua: 'Три запитання на папері показують, хто зрозумів, ще до дзвінка.'
          },
          best: 15
        }
      ],
      explain: {
        en: '15% is 7 minutes of recap, enough to hook memory. 35% is about 16 minutes of new material, the edge of what one voice can hold. Group work gets the same 16 minutes so it is real work, and the last 7 minutes tell you what to fix on Friday.',
        ua: '15% — це 7 хвилин повторення, достатньо, щоб зачепити пам’ять. 35% — близько 16 хвилин нового матеріалу, межа того, що втримає один голос. Групова робота отримує ті самі 16 хвилин, щоб стати справжньою роботою, а останні 7 хвилин показують, що виправляти в п’ятницю.'
      },
      fx: { ok: { learning: 6 }, fail: { learning: -4 } }
    },
    {
      type: 'queue',
      id: 's5',
      at: '11:15',
      comp: ['organisation', 'communication'],
      traits: ['C', 'S'],
      text: {
        en: 'Three messages during the break. Open them in the order you think is right and answer each.',
        ua: 'Три повідомлення за перерву. Відкрий їх у тому порядку, який вважаєш правильним, і відповідай на кожне.'
      },
      tickets: [
        {
          id: 't1',
          from: 'principal',
          urgency: 3,
          sla: { en: 'by 12:00', ua: 'до 12:00' },
          subject: { en: 'Inspection list', ua: 'Список для перевірки' },
          body: {
            en: 'I need the 8-A medical check list and the signed safety log on my desk by 12:00. The inspector is already in the building.',
            ua: 'Мені потрібен список 8-А на медогляд і підписаний журнал інструктажу на столі до 12:00. Перевіряюча вже в школі.'
          },
          options: [
            {
              text: {
                en: 'Reply: "Log is signed, bringing it at 11:25 with the list. The list has 26 names, two lack a parent\'s signature, I have flagged them." Then walk it over.',
                ua: 'Відповісти: «Журнал підписаний, принесу об 11:25 разом зі списком. У списку 26 прізвищ, у двох бракує підпису батьків, я їх позначив». І віднести.'
              },
              q: 'best',
              fx: { admin: 5, trust: 3 },
              fb: {
                en: 'The principal gets a time and the state of the gaps before the inspector asks. Flagged gaps are a plan; hidden ones are a finding.',
                ua: 'Директор отримує час і стан прогалин ще до запитань перевіряючої. Позначені прогалини — це план; приховані — це зауваження.'
              }
            },
            {
              text: {
                en: 'Reply "On it, will bring both before 12:00" and sort out the two missing signatures first so that the list goes up complete.',
                ua: 'Відповісти «Роблю, принесу обидва до 12:00» і спершу зібрати два відсутні підписи, щоб список пішов нагору повним.'
              },
              q: 'ok',
              fx: { admin: 2, energy: -4 },
              fb: {
                en: 'Complete is nice, but two parents will not sign in 35 minutes, and the principal now does not know the list has holes. Report a gap, do not chase it.',
                ua: 'Повний список — добре, але двоє батьків за 35 хвилин не підпишуть, а директор не знає, що в списку діри. Прогалину повідомляють, а не ганяються за нею.'
              }
            },
            {
              text: {
                en: "Reply that you have lessons until 13:00 and will bring the papers after; the inspector has the whole day, and this is not really the form teacher's job.",
                ua: 'Відповісти, що в тебе уроки до 13:00 і папери принесеш після; у перевіряючої цілий день, і це взагалі не зовсім робота класного керівника.'
              },
              q: 'bad',
              fx: { admin: -6, trust: -5 },
              fb: {
                en: "It is the form teacher's job, the deadline is 12:00, and the principal is standing next to the inspector. You made your problem his, in writing.",
                ua: 'Це саме робота класного керівника, дедлайн 12:00, а директор стоїть поруч із перевіряючою. Ти зробив свою проблему його проблемою, письмово.'
              }
            }
          ]
        },
        {
          id: 't2',
          from: 'maksym',
          urgency: 2,
          sla: { en: 'this break', ua: 'ця перерва' },
          subject: { en: 'The test I missed', ua: 'Контрольна, яку я пропустив' },
          body: {
            en: 'I was sick on the day of the test. Mum says I have to rewrite it. When can I? I have football every day after school except Thursday.',
            ua: 'Я хворів у день контрольної. Мама каже, що маю переписати. Коли можна? Після школи щодня футбол, крім четверга.'
          },
          options: [
            {
              text: {
                en: 'Reply: "Thursday 14:00, room 12, the same four parts. Bring your source-analysis notes." Put it in your calendar before the bell goes.',
                ua: 'Відповісти: «Четвер, 14:00, кабінет 12, ті самі чотири частини. Візьми конспект з аналізу джерел». І записати в календар до дзвінка.'
              },
              q: 'best',
              fx: { learning: 3, trust: 2 },
              fb: {
                en: 'A student who asks to rewrite wants the grade. He got a day, a room and a hint; you got one fewer loose end before the call with his mother.',
                ua: 'Учень, який просить переписати, хоче оцінку. Він отримав день, кабінет і підказку; ти — на один хвіст менше перед дзвінком його мамі.'
              }
            },
            {
              text: {
                en: 'Tell him to come after any lesson this week and you will find a moment; the football schedule is his to manage, not yours.',
                ua: 'Сказати, щоб підійшов після будь-якого уроку цього тижня, і ти знайдеш момент; розклад футболу — його справа, а не твоя.'
              },
              q: 'ok',
              fx: { trust: -1 },
              fb: {
                en: '"Any lesson" means none. Teenagers need a time written down, and you will spend Friday wondering why he never came.',
                ua: '«Після будь-якого уроку» означає «ніколи». Підліткам потрібен записаний час, а ти в п’ятницю думатимеш, чому він не прийшов.'
              }
            },
            {
              text: {
                en: 'Tell him his mother already has a call with you today and you will settle the rewrite with her; a corridor is not the place to arrange it.',
                ua: 'Сказати, що з мамою в тебе сьогодні і так дзвінок, і переписування ти владнаєш із нею; коридор — не місце, щоб про таке домовлятись.'
              },
              q: 'bad',
              fx: { learning: -3, climate: -3 },
              fb: {
                en: 'He asked you directly, like an adult, and you sent him to his mother. The lesson he takes away is that his own initiative does not count here.',
                ua: 'Він звернувся напряму, як дорослий, а ти відправив його до мами. Урок, який він виносить: його власна ініціатива тут не рахується.'
              }
            }
          ]
        },
        {
          id: 't3',
          from: 'colleague',
          urgency: 1,
          sla: { en: 'by 13:00', ua: 'до 13:00' },
          subject: { en: 'Can you cover lesson 6?', ua: 'Підміниш шостий урок?' },
          body: {
            en: 'I have a dentist at 14:00 that I cannot move. Could you take my 7-B at lesson 6? They have a worksheet, they just need an adult in the room.',
            ua: 'У мене стоматолог о 14:00, перенести не можу. Візьмеш мій 7-Б на шостому уроці? У них є робочий аркуш, потрібен просто дорослий у класі.'
          },
          options: [
            {
              text: {
                en: 'Say yes if lesson 6 is free for you, ask her to leave the worksheet and the register on the desk, and tell the deputy head so the substitution is recorded.',
                ua: 'Погодитись, якщо шостий у тебе вільний, попросити лишити аркуш і журнал на столі й повідомити заступницю, щоб заміну зафіксували.'
              },
              q: 'best',
              fx: { admin: 2, trust: 2 },
              fb: {
                en: 'Favours are the currency of a staffroom, and a recorded substitution protects both of you if anything happens in that room.',
                ua: 'Послуги — валюта вчительської, а зафіксована заміна захищає вас обох, якщо в тому класі щось станеться.'
              }
            },
            {
              text: {
                en: 'Agree straight away and sort out the paperwork later; she needs an answer now, and the deputy head will understand a late note.',
                ua: 'Погодитись одразу, а папери владнати потім; їй потрібна відповідь зараз, а заступниця зрозуміє, якщо повідомити пізніше.'
              },
              q: 'ok',
              fx: { trust: 1, admin: -2 },
              fb: {
                en: 'Kind, and most days fine. The day a child gets hurt in a room where you are not officially present is the day "later" costs you.',
                ua: 'По-людськи, і в більшість днів нормально. Того дня, коли дитина поранилась у класі, де ти офіційно не присутній, «потім» коштує дорого.'
              }
            },
            {
              text: {
                en: 'Decline: you have grading, the call with Iryna and the open lesson; 7-B is not your class, and she can ask the deputy head to find someone.',
                ua: 'Відмовити: у тебе перевірка робіт, дзвінок Ірині Петрівні й відкритий урок; 7-Б не твій клас, нехай попросить заступницю когось знайти.'
              },
              q: 'bad',
              fx: { trust: -4 },
              fb: {
                en: 'Every reason is true, and the staffroom will remember the no. Next month it is your dentist appointment, and the no comes back.',
                ua: 'Кожна причина правдива, а вчительська запам’ятає відмову. Наступного місяця стоматолог у тебе, і відмова повернеться.'
              }
            }
          ]
        }
      ]
    },
    {
      type: 'numeric',
      id: 's6',
      at: '12:10',
      comp: ['pedagogy'],
      traits: ['C', 'I'],
      text: {
        en: "Before the call with Iryna you work out Maksym's thematic grade. Current grades count once each; the thematic test counts twice. The school uses a 12-point scale.",
        ua: 'Перед дзвінком Ірині Петрівні рахуєш тематичну оцінку Максима. Поточні оцінки рахуються по одному разу, тематична контрольна — удвічі. Шкала 12-бальна.'
      },
      data: [
        { label: { en: 'Current grades', ua: 'Поточні оцінки' }, value: '8, 6, 9' },
        { label: { en: 'Thematic test', ua: 'Тематична контрольна' }, value: '5' },
        { label: { en: 'Weight of the test', ua: 'Вага контрольної' }, value: '×2' }
      ],
      question: {
        en: 'What is the weighted average, to one decimal?',
        ua: 'Яке середнє зважене, з точністю до десятих?'
      },
      answer: 6.6,
      tolerance: 0.02,
      unit: { en: 'points', ua: 'бали' },
      hint: {
        en: 'Add the grades, counting the test twice, then divide by the number of entries you counted.',
        ua: 'Додай оцінки, рахуючи контрольну двічі, і поділи на кількість врахованих записів.'
      },
      explain: {
        en: '8 + 6 + 9 + 5 + 5 = 33. Five entries, so 33 ÷ 5 = 6.6. The thematic grade rounds to 7, not to the 5 on the test, and that is the number to bring to the call.',
        ua: '8 + 6 + 9 + 5 + 5 = 33. П’ять записів, тож 33 ÷ 5 = 6,6. Тематична округлюється до 7, а не до 5 з контрольної, і саме цю цифру несеш на дзвінок.'
      },
      fx: { ok: { learning: 4, trust: 2 }, fail: { learning: -4 } }
    },
    {
      type: 'spot',
      id: 's7',
      at: '13:40',
      comp: ['organisation'],
      traits: ['C'],
      text: {
        en: 'You open the electronic register for lesson 3 and look over what you entered during the break. There are 3 mistakes. Tap each one.',
        ua: 'Ти відкриваєш електронний журнал за третій урок і переглядаєш, що вніс на перерві. У записі 3 помилки. Натисни на кожну.'
      },
      mock: {
        kind: 'table',
        title: { en: 'E-register · 8-A · History', ua: 'Е-журнал · 8-А · Історія' },
        blocks: [
          {
            id: 'b1',
            kind: 'heading',
            label: {
              en: 'Lesson 3, Wednesday · 12-point scale',
              ua: 'Урок 3, середа · 12-бальна шкала'
            },
            value: ''
          },
          { id: 'b2', kind: 'field', label: { en: 'Date', ua: 'Дата' }, value: '08.10.2026' },
          {
            id: 'b3',
            kind: 'field',
            label: { en: 'Topic', ua: 'Тема' },
            value: { en: 'The Union of Lublin, 1569', ua: 'Люблінська унія, 1569 р.' }
          },
          {
            id: 'b4',
            kind: 'field',
            label: { en: 'Attendance', ua: 'Присутні' },
            value: { en: '27 of 26 enrolled', ua: '27 із 26 за списком' },
            issue: {
              en: 'Twenty-seven present out of twenty-six on the list. Someone was counted twice, or the class size is wrong.',
              ua: 'Двадцять сім присутніх із двадцяти шести за списком. Когось порахували двічі або неправильна кількість учнів.'
            }
          },
          { id: 'b5', kind: 'line', label: { en: 'Sofiia K.', ua: 'Софія К.' }, value: '9' },
          {
            id: 'b6',
            kind: 'line',
            label: { en: 'Maksym B.', ua: 'Максим Б.' },
            value: '14',
            issue: {
              en: 'The scale is 12-point; a 14 cannot exist. Probably an 11 or a 4 with a slipped finger.',
              ua: 'Шкала 12-бальна; оцінки 14 не існує. Імовірно, 11 або 4 і промах пальцем.'
            }
          },
          { id: 'b7', kind: 'line', label: { en: 'Danylo R.', ua: 'Данило Р.' }, value: '7' },
          {
            id: 'b8',
            kind: 'field',
            label: { en: 'Homework', ua: 'Домашнє завдання' },
            value: {
              en: '§ 12, questions 1–5, due 06.10.2026',
              ua: '§ 12, запитання 1–5, здати до 06.10.2026'
            },
            issue: {
              en: 'Due two days before the lesson it was set in. The date should be the next lesson, 10.10.',
              ua: 'Здати за два дні до уроку, на якому задали. Дата має бути наступного уроку, 10.10.'
            }
          },
          { id: 'b9', kind: 'button', label: { en: 'Save', ua: 'Зберегти' }, value: '' }
        ]
      },
      explain: {
        en: 'Attendance above the class size, a grade above the scale and a homework due date in the past. Each one is a typo on its own; together they are what a parent screenshots into the group chat.',
        ua: 'Присутніх більше, ніж учнів, оцінка понад шкалу й дата здачі домашнього в минулому. Кожна окремо — одрук; разом це те, що батьки скріншотять у груповий чат.'
      },
      fx: { ok: { admin: 6 }, fail: { admin: -5 } }
    },
    {
      type: 'chat',
      id: 's8',
      at: '14:30',
      comp: ['care', 'communication'],
      traits: ['S', 'I'],
      messages: [
        {
          from: 'sofiia',
          text: {
            en: 'Can I stay in the classroom until seven? I can help with the open lesson. I just do not want to go home yet.',
            ua: 'Можна я посиджу в класі до сьомої? Можу допомогти з відкритим уроком. Просто не хочу поки додому.'
          }
        },
        {
          from: 'sofiia',
          text: {
            en: 'Only please do not tell anyone I said that. Especially not Dad. Promise?',
            ua: 'Тільки, будь ласка, нікому не кажіть, що я це сказала. Особливо татові. Обіцяєте?'
          }
        }
      ],
      prompt: { en: 'What do you say?', ua: 'Що ти кажеш?' },
      options: [
        {
          text: {
            en: 'Sit down with her: "I am glad you told me. I cannot promise to keep everything secret, because if you are not safe I have to act. But nothing happens without you knowing. Will you come with me to Alina tomorrow?"',
            ua: 'Сісти поруч: «Добре, що ти сказала. Пообіцяти, що все лишиться в таємниці, не можу: якщо тобі небезпечно, я мушу діяти. Але нічого не станеться без твого відома. Підеш зі мною завтра до Аліни?»'
          },
          q: 'best',
          fx: { climate: 4, trust: 4 },
          fb: {
            en: 'She hears honesty instead of a promise you may have to break, and a next step with a name on it. The psychologist is trained for this conversation; you are trained to open it.',
            ua: 'Вона чує чесність замість обіцянки, яку, можливо, доведеться порушити, і наступний крок з іменем. Психологиня навчена вести цю розмову; ти навчений її відкрити.'
          }
        },
        {
          text: {
            en: 'Let her stay, tell her she can always talk to you, give her your number and check in with her again on Friday before deciding anything else. She needs one adult she trusts first.',
            ua: 'Дозволити лишитись, сказати, що вона завжди може з тобою поговорити, дати свій номер і знову поговорити в п’ятницю, перш ніж щось вирішувати. Їй спершу потрібен один дорослий, якому вона довіряє.'
          },
          q: 'ok',
          fx: { trust: 2, climate: 1 },
          fb: {
            en: 'Warm and well meant, but you are now the only adult who knows, with no training and no plan. Two days is long if something is happening at home.',
            ua: 'Тепло й зі щирим наміром, але тепер ти єдиний дорослий, який знає, без підготовки й без плану. Два дні — це довго, якщо вдома щось відбувається.'
          },
          later: {
            after: 1,
            note: {
              en: 'Sofiia did not come to school on Thursday. Nobody answers the home phone.',
              ua: 'У четвер Софія не прийшла до школи. Домашній телефон не відповідає.'
            },
            fx: { climate: -5 }
          }
        },
        {
          text: {
            en: 'Promise. "Of course, this stays between us." Then let her stay and keep an eye on her over the next weeks; trust is the only thing that will make her talk more.',
            ua: 'Пообіцяти. «Звісно, це лишиться між нами». Дозволити лишитись і наглядати за нею наступні тижні; довіра — єдине, що змусить її говорити далі.'
          },
          q: 'bad',
          fx: { climate: 2, trust: -5 },
          fb: {
            en: 'A promise of secrecy to a child who may be at risk is one you will have to break, and then she learns adults lie. Honesty now costs less than that.',
            ua: 'Обіцянка таємниці дитині, яка може бути в небезпеці, — це обіцянка, яку доведеться порушити, і тоді вона дізнається, що дорослі брешуть. Чесність зараз коштує менше.'
          }
        },
        {
          text: {
            en: 'Call Oleh right away, as her father has a right to know, and ask him what is going on at home before the situation grows into something bigger.',
            ua: 'Одразу зателефонувати Олегу, бо батько має право знати, і спитати, що відбувається вдома, поки ситуація не розрослась у щось більше.'
          },
          q: 'bad',
          fx: { climate: -8, trust: -6 },
          fb: {
            en: 'She asked you not to tell Dad; that sentence is the information. Calling him first can put her in danger and ends any chance she talks to a teacher again.',
            ua: 'Вона просила не казати татові; це речення і є інформація. Дзвінок йому першому може наразити її на небезпеку й закриває будь-який шанс, що вона ще колись звернеться до вчителя.'
          }
        }
      ],
      principle: {
        en: 'Listen, do not promise secrecy, bring in the psychologist.',
        ua: 'Вислухай, не обіцяй таємниці, залучи психолога.'
      }
    }
  ],
  verdict: {
    bands: [
      {
        min: 0.8,
        title: {
          en: 'The teacher 8-A will remember in twenty years',
          ua: 'Учитель, якого 8-А згадуватиме через двадцять років'
        },
        text: {
          en: 'You kept grades private, gave the disruptor a job and told a child the truth about what you could promise. That is the whole craft.',
          ua: 'Ти тримав оцінки приватними, дав порушнику роботу й сказав дитині правду про те, що можеш обіцяти. Це і є все ремесло.'
        }
      },
      {
        min: 0.6,
        title: { en: 'A good teacher with a tired chat', ua: 'Хороший учитель із втомленим чатом' },
        text: {
          en: 'The classroom calls were right; the slips were in writing, saying in a group what belonged in a call.',
          ua: 'Рішення в класі були правильні; промахи — у письмі: ти казав у групі те, що належало дзвінку.'
        }
      },
      {
        min: 0.4,
        title: {
          en: 'The lessons would be fine, the rest would not',
          ua: 'З уроками було б добре, з рештою ні'
        },
        text: {
          en: 'You tend to answer the loudest person instead of the person in front of you. Re-read the feedback on the chat and on Sofiia.',
          ua: 'Ти схильний відповідати найгучнішому, а не тому, хто перед тобою. Перечитай фідбек про чат і про Софію.'
        }
      },
      {
        min: 0,
        title: {
          en: 'This school would have worn you down by October',
          ua: 'Ця школа змотала б тебе до жовтня'
        },
        text: {
          en: 'Many choices protected you from parents instead of protecting children from the day. The job is the second one.',
          ua: 'Багато рішень захищали тебе від батьків замість захищати дітей від цього дня. Робота — це друге.'
        }
      }
    ],
    reality: [
      {
        en: 'Five lessons are 225 minutes; the e-register, logs and chats take another two hours, most of it after 17:00.',
        ua: 'П’ять уроків — це 225 хвилин; е-журнал, журнали інструктажів і чати забирають ще дві години, здебільшого після 17:00.'
      },
      {
        en: 'A form teacher handles two or three parent conversations a week that have nothing to do with the subject.',
        ua: 'Класний керівник веде дві-три батьківські розмови на тиждень, які не мають стосунку до предмета.'
      },
      {
        en: 'You will grade roughly 3 000 pieces of student work a year, most of them at your kitchen table.',
        ua: 'За рік ти перевіриш близько 3 000 учнівських робіт, більшість із них за кухонним столом.'
      }
    ]
  }
};
